export default function debugp() {
  if(!window.Apos.debug)
    return;

  console.log.apply(console, arguments);
}
